
<script>
    import PreviewComponent from "./PreviewComponent";    
    import PaymentAuthenticationComponent from '../../components/pagesbuilder/dynamic-components/PaymentAuthenticationComponent';
    import {mapGetters} from 'vuex';
    

    export default {
        name: "PreviewPaymentAuthenticationComponent",
        mixins: [PreviewComponent, PaymentAuthenticationComponent],        
        computed:{
            signedIn(){
                return this.hasAuthenticated || this.isLoggedIn;
            },
            ...mapGetters('user', [
                'isLoggedIn'
            ]),           
        }
    }
</script>
